export const UrlCor = () => "SERVIDOR_JAVA_INACCESIBLE_(ECO-API)"
export const UrlSeg = () => "SERVIDOR_JAVA_INACCESIBLE_(ARES)"
export const UrlMsa = () => "SERVIDOR_JAVA_INACCESIBLE_(MESAS)"

export const UrlWsUsuarios = () => process.env.REACT_APP_API_BASE + '/usuarios'
//export const UrlWsUsuarios = () => "https://peraflop.com.ar/api/usuarios"
//export const UrlWsUsuarios = () => "https://pre.usuarios.api.peraflop.com.ar"
//export const UrlWsUsuarios = () => "http://localhost:8000/usuarios"

export const UrlWsClientes = () => process.env.REACT_APP_API_BASE + '/clientes'
//export const UrlWsClientes = () => "https://peraflop.com.ar/api/clientes"
//export const UrlWsClientes = () => "https://pre.clientes.api.peraflop.com.ar"
//export const UrlWsClientes = () => "http://localhost:8000/clientes"

export const UrlWsInventarios = () => process.env.REACT_APP_API_BASE + '/inventarios'
//export const UrlWsInventarios = () => "https://peraflop.com.ar/api/inventarios"
//export const UrlWsInventarios = () => "https://pre.inventarios.api.peraflop.com.ar"
//export const UrlWsInventarios = () => "http://localhost:8000/productos"

export const UrlWsCajas = () => process.env.REACT_APP_API_BASE + '/cajas'
//export const UrlWsCajas = () => "https://peraflop.com.ar/api/cajas"
//export const UrlWsCajas = () => "https://pre.cajas.api.peraflop.com.ar"
//export const UrlWsCajas = () => "http://localhost:8000/cajas"
